<template>
  <div class="top-filter-dropdown-container">
      <div class="top-filter-dropdown-group">
        <transition name="slide">
            <div class="top-filter-dropdown-list" v-if="show">
                <div class="title">
                    {{ $t('globalComponents.selectWarehouse') }}
                </div>
                <div class="top-filter-dropdown-div">
                  <el-input
                    v-model="searchText"
                    v-alphanumeric-validation
                    maxlength="50"
                    clearable
                    @change="search"
                    class="inline-input"
                    size="mini"
                    suffix-icon="el-icon-search"
                    id="search-warehouse-list"
                    ref="search-warehouse-list"
                    ></el-input>
                </div>
                <div class="list">
                    <div v-bind:key="warehouse.id" v-for="warehouse in warehouse.list" class="list-item">
                       <span class="span-check">
                            <el-radio v-model="user.warehouseCode" :label="warehouse.code" @change="change(warehouse)">
                                {{"  "}}
                            </el-radio>
                        </span>
                        <span class="span-name">
                            {{ warehouse.name }} - {{ warehouse.code }}
                        </span>
                    </div>
                </div>
            </div>
        </transition>
        <div class="top-filter-dropdown-selected">
            <span class="top-filter-dropdown-label"> {{ user.warehouseLabel }} </span>
            <span class="top-filter-dropdown-change">
                <!-- If user.groups.length means that doesnt have an specific warehouse and must show all -->
                <el-button icon="fa fa-random"  size="mini" circle @click="openList" v-if="user.warehouseCode && !user.groups.length"></el-button>
            </span>
        </div>
      </div>
    <div class="component-container-overlay"  v-if="show"></div>
</div>
</template>

<script>
/**
 * This component is for internal and warehouse users, in this users the auth0 is the warehouse of user.
 * If the user doenst have any group then user can access to all warehouses.
 */
import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'WarehouseList',
  props: {
    /* An array of vuex actions to be called when a warehouse is selected.
     * These actions will be called orderd by position, in waterfall mode.
     * Can contain strings or another arrays. If a given position have a string
     * an action with the string value will be invoked. If a given position
     * have an array, the first position of the internal array will be used
     * as action name. The rest of positions will be used as action parameters.
     */
    actionStrSelectChained: {
      type: Array,
      default: null
    },
    actionStrMountChained: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      show: false,
      searchText: ''
    };
  },
  computed: {
    ...mapGetters([
      'warehouse',
      'user',
      'orderEntry'
    ])
  },
  methods: {
    search() {
      // If sarch text is changed
      if (this.searchText !== this.warehouse.filters.search) {
        this.$store.dispatch('warehouse/getWarehouseCodes', { search: this.searchText });
      }
    },
    async change(warehouseSelected) {
      this.$store.dispatch('setWarehouse', warehouseSelected);
      const loading = Loading.service(constants.LOADING.DEFAULT_CONFIG);
      await this.callSelectAction();
      loading.close();
      this.show = false;
    },
    openList() {
      this.show = !this.show;
      // Its necessary nextTick because we need to wait the component render.
      if (this.show) {
        this.$nextTick(() => {
          this.$refs['search-warehouse-list'].focus();
        });
      }
    },
    async callSelectAction() {
      if (this.actionStrSelectChained) {
        for (const action of this.actionStrSelectChained) {
          if (Array.isArray(action) && action.length > 0) {
            const actionName = action.slice(0, 1).toString();
            const actionParams = action.slice(1);
            await this.$store.dispatch(actionName, ...actionParams);
          } else {
            await this.$store.dispatch(action);
          }
        }
      }
    },
    async callMountAction() {
      if (this.actionStrMountChained) {
        for (const action of this.actionStrMountChained) {
          if (Array.isArray(action) && action.length > 0) {
            const actionName = action.slice(0, 1).toString();
            const actionParams = action.slice(1);
            await this.$store.dispatch(actionName, ...actionParams);
          } else {
            await this.$store.dispatch(action);
          }
        }
      }
    }
  },
  async mounted() {
    this.callMountAction();
    const resetSearch = true;
    if (this.user.warehouseCode) {
      this.callSelectAction();
      // Call reset search but without loading because the warehouse is already selected, and no need await.
      this.search(resetSearch);
    } else {
      const loading = Loading.service(constants.LOADING.DEFAULT_CONFIG);
      await this.$store.dispatch('warehouse/getWarehouseCodes', { text: 'Loading Groups', search: this.searchText });

      // Show component open when warehouse list greater than zero and it doesnt have a specific warehouse and must show all
      this.show = this.warehouse.list.length > 1 && !this.user.groups.length;

      // Select the user's group as warehouse.
      if (this.warehouse.list.length && this.user.groups.length) {
        const warehouseSelected = this.warehouse.list.find(element => element.code === this.user.groups[0]);
        this.change(warehouseSelected);
      }
      loading.close();
    }

    // Its necessary nextTick because we need to wait the component render.
    if (this.show) {
      this.$nextTick(() => {
        this.$refs['search-warehouse-list'].focus();
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .top-filter-dropdown-container {
        .top-filter-dropdown-group {
            .top-filter-dropdown-selected {
                color: #466825;
                .is-circle {
                    background-color: #466825;
                }
                &:before {
                    background-color: #c3dece;
                }
            }
        }
    }
</style>
